export default "__VITE_ASSET__836987c7__"